module.exports = __webpack_public_path__ + "static/media/movimento-por-uma-cultura-de-doação.9ea97854.png";